<table class="table table-bordered table-hover schedule-table">
    <tbody>
        @for (recurrence of recurrences; track recurrence) {
            <tr>
                <th scope="row">
                    <i class="fal {{ recurrence.completed ? 'fa-square-check' : 'fa-square' }} me-1"
                       [style.color]="recurrence.section.colour"></i>
                    {{ recurrence.section.code }}
                </th>
                <td>
                    @if (recurrence.completed) {
                        completed
                    }
                    @if (!recurrence.completed) {
                        to be done {{ recurrence.scheduleText }}
                    }
                    @if (!recurrence.hasMeetings && !recurrence.completed) {
                        <div>
                            <small>There are no scheduled meetings for your {{ recurrence.section.name }} sessions.</small>
                        </div>
                    }
                </td>
            </tr>
        }
    </tbody>
</table>
